import { Component, Inject, Input, OnInit } from '@angular/core';
import { Component as BrComponent } from '@bloomreach/spa-sdk/';
import { Page } from '@bloomreach/spa-sdk';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import {
  assetStatistics,
  FundUmbrella,
  LiteratureDocument,
  PortfolioDisplay,
  positionStatistics,
  Statistic,
} from '@types';
import { Logger } from '@utils/logger';
import { PortfolioService } from '../portfolio.service';
import { take } from 'rxjs/operators';
import { WINDOW } from '@ng-web-apis/common';
import { AnalyticsService } from '@frk/eds-components';

const logger = Logger.getLogger('StatisticsAndPositionsComponent');

export interface StatisticsAndPositionsData {
  fundUmbrella?: FundUmbrella;
  statistics: Statistic[];
}

@Component({
  selector: 'ft-statistics-and-positions',
  templateUrl: './statistics-and-positions.component.html',
  styleUrls: ['./statistics-and-positions.component.scss'],
})
export class StatisticsAndPositionsComponent
  extends BaseProductDetailComponent
  implements OnInit, PortfolioDisplay {
  @Input() data: StatisticsAndPositionsData;
  @Input() page!: Page;
  @Input() component!: BrComponent;
  assets: Statistic[] = [];
  positions: Statistic[] = [];
  otherStatistics: Statistic[] = [];
  public isPopulated = false;
  config; // TODO: this needs a type defined

  isDocumentAvailable = false;

  private documentLink: string;
  documentData: LiteratureDocument;

  constructor(
    private analytics: AnalyticsService,
    private portfolioService: PortfolioService,
    @Inject(WINDOW) readonly windowRef: Window
  ) {
    super();
  }

  ngOnInit(): void {
    this.setConfig();
  }

  public setConfig(): void {
    this.config = this.component?.getModels()?.config;
  }

  /**
   * When data is passed into this component, this function checks if it can be displayed
   * Called direct from Entry component, as ngOnInit and ngOnchanges not called when dynamic component
   */
  public processData(): void {
    this.setConfig();
    this.isDocumentAvailable = false;
    logger.debug('processData()', this.data);
    this.isPopulated =
      this.data && this.data.statistics && this.data.statistics.length > 0;
    this.data.statistics.forEach((stat: Statistic): void => {
      if (stat.tooltip) {
        stat = { ...stat, tooltipName: stat.label };
      }
      if (
        assetStatistics.some((assetId: string): boolean => stat.id === assetId)
      ) {
        this.assets.push(stat);
      } else if (
        positionStatistics.some(
          (positionId: string): boolean => stat.id === positionId
        )
      ) {
        this.positions.push(stat);
      } else {
        this.otherStatistics.push(stat);
      }
    });
    this.setDownloadUrl();
    logger.debug('assetStatistics', assetStatistics);
    logger.debug('positionStatistics', positionStatistics);
    logger.debug('assets', this.assets);
    logger.debug('positions', this.positions);
    logger.debug('otherStatistics', this.otherStatistics);
  }

  private setDownloadUrl() {
    this.portfolioService
      .getDownloadUrl(
        this.config?.fundId,
        this.config?.shareClassCode,
        this.data.fundUmbrella
      )
      .pipe(take(1))
      .subscribe((documentData: LiteratureDocument) => {
        if (documentData.pdfDownloadLink) {
          this.documentLink = documentData.pdfDownloadLink;
          this.documentData = documentData;
          this.isDocumentAvailable = true;
        }
      });
  }

  openDocument(documentData: LiteratureDocument) {
    this.analytics.trackEvent({
      event: 'file_download',
      action: 'download pdf',
      file_name: documentData.dctermsTitle,
      file_lit_code: documentData.docId,
    });
    this.windowRef.open(this.documentLink, '_blank');
  }
}
